var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.show),expression:"!!show"}],staticClass:"evaluate-score-group"},[_c('div',{staticClass:"evaluate-score"},[_vm._v(" "+_vm._s(_vm.$t('evaluate_common_total_score'))+"："+_vm._s(parseInt(_vm.score))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }